"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumFromValue = exports.getPureEnum = exports.getEnumValues = exports.getEnumKeys = void 0;
function getEnumKeys(enu) {
    return Object.keys(enu).filter(function (key) {
        return (isNaN(Number(key)) || /^0\d+/.test(key)) && (typeof enu[key] === 'string' || typeof enu[key] === 'number');
    });
}
exports.getEnumKeys = getEnumKeys;
function getEnumValues(enu) {
    return getEnumKeys(enu).map(function (key) { return enu[key]; });
}
exports.getEnumValues = getEnumValues;
function getPureEnum(enu) {
    return Object.fromEntries(getEnumKeys(enu).map(function (key) { return [key, enu[key]]; }));
}
exports.getPureEnum = getPureEnum;
function enumFromValue(enu, val) {
    var parsed = (getEnumValues(enu).includes(val) ? val : undefined);
    if (parsed === undefined) {
        throw new Error("Invalid enum member ".concat(typeof val === 'string' ? "\"".concat(val, "\"") : val, ". ").concat(JSON.stringify(getPureEnum(enu))));
    }
    return parsed;
}
exports.enumFromValue = enumFromValue;
//# sourceMappingURL=enums.js.map